module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/portability-42776f6a55eb160b6a5e1fbf6810a2df.svg";